import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '../containers';
import { FullPageSpinner } from '../components';

const LoginPage = lazy(() => import('../pages/login'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password'));
const MemberListPage = lazy(() => import('../pages/members'));
const MemberFormPage = lazy(() => import('../pages/member-form'));

export const DefaultRouter = () => (
    <BrowserRouter>
        <Suspense fallback={<FullPageSpinner />}>
            <Routes>
                <Route path="/" element={<Layout authPage />}>
                    <Route index element={<LoginPage />} />
                    <Route path="login" element={<LoginPage />} />
                    <Route path="forgot-password" element={<ForgotPasswordPage />} />
                </Route>
                <Route path="/home" element={<Layout />}>
                    <Route index element={<MemberListPage />} />
                     {/*Additional routes can be added here*/}
                </Route>
                <Route path="/member-management" element={<Layout  childPage />}>
                    <Route index element={<MemberFormPage />} />
                    <Route path=":memberId" element={<MemberFormPage />} />
                </Route>
            </Routes>
        </Suspense>
    </BrowserRouter>
);
